// MobileBar.jsx — porting React di #wsh-modbar + #wsh-modsheet (workspace-host.js:104-183,
// UX già collaudata). STESSI id e classi DOM: il CSS wsh-* verbatim (legacy-bridge)
// li veste identici. Visibile solo <768px (media query), auth-gated dal frame (§5).
// Tutte le label passano dal glossario (B2.17): zero testi hardcodati qui.
// Ondata 6: il fondo del modsheet ospita la STESSA zona utente del rail desktop
// (UserZone: pill+nome, lingua, logout con conferma); lo sheet sezioni apre con
// l'header di contesto del modulo (titolo+sottotitolo, resa unica SubmenuHeader).

import React from 'react';
import { label } from './glossary.js';
import { SubmenuList, SubmenuHeader } from './Submenu.jsx';
import { UserZone } from './UserZone.jsx';

// Glifi VERBATIM da wsh:110 e wsh:116.
function ModuleGlyph() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
    </svg>
  );
}
function MenuGlyph() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  );
}

// Iniziali del badge modulo nel modsheet (wsh:169 VERBATIM).
function initials(lbl) {
  return (lbl || '?').replace(/[^A-Za-z0-9À-ÿ]/g, '').slice(0, 2).toUpperCase();
}

export function MobileBar({ host }) {
  const [, setTick] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [secOpen, setSecOpen] = React.useState(false);

  React.useEffect(() => {
    // ogni activate/deactivate/registrazione: chiudi gli sheet (closeModsheet di
    // wsh) e ridisegna barra + elenchi (updateModbar di wsh).
    return host.subscribe(() => {
      setOpen(false);
      setSecOpen(false);
      setTick((t) => t + 1);
    });
  }, [host]);

  const current = host.currentModuleLabel();
  // R3: se il modulo attivo ha il sottomenù shell, la metà destra apre lo sheet
  // SEZIONI della shell (stessa lista del desktop: resa unica §6.1); altrimenti
  // resta il comportamento legacy (hamburger interno del modulo).
  const sub = host.submenuData();

  function onSectionsTap() {
    if (sub) setSecOpen((v) => !v);
    else host.openSectionMenu();
  }

  return (
    <React.Fragment>
      <div id="wsh-modbar">
        <button
          className="mb-half mb-left" type="button"
          aria-label={label('shell.modbar.change_module')}
          onClick={() => { setSecOpen(false); setOpen(true); }}
        >
          <ModuleGlyph />
          <span>{current.toUpperCase()}</span>
        </button>
        <button
          className="mb-half mb-right" type="button"
          aria-label={label('shell.modbar.sections_menu')}
          onClick={onSectionsTap}
        >
          <MenuGlyph />
          <span>{label('shell.modbar.menu')}</span>
        </button>
      </div>
      <div
        id="wsh-modsheet-bg"
        className={open ? 'open' : ''}
        onClick={(e) => { if (e.target === e.currentTarget) setOpen(false); }}
      >
        <div id="wsh-modsheet">
          <h4>{label('shell.modsheet.title')}</h4>
          {open && host.moduleList().map((m) => (
            <div
              key={m.key}
              className={'wsh-mod' + (m.activeNow ? ' active' : '')}
              onClick={() => { setOpen(false); host.select(m); }}
            >
              <span className="mi">{initials(m.label)}</span>
              {m.label}
              {m.badge > 0 && <span className="sm-badge" style={{ marginLeft: 'auto' }}>{m.badge > 99 ? '99+' : m.badge}</span>}
            </div>
          ))}
          {open && <UserZone host={host} variant="sheet" />}
        </div>
      </div>
      <div
        id="shell-secsheet-bg"
        className={secOpen && sub ? 'open' : ''}
        onClick={(e) => { if (e.target === e.currentTarget) setSecOpen(false); }}
      >
        <div id="shell-secsheet">
          {sub && <SubmenuHeader title={sub.title} subtitle={sub.subtitle} />}
          {secOpen && sub && (
            <React.Fragment>
              <div className="sm-actions">
                {sub.id === 'proc' && !!document.getElementById('sb-quick-quote') && (
                  <button type="button" className="sm-action" onClick={() => { setSecOpen(false); document.getElementById('sb-quick-quote').click(); }}>
                    {label('proc.quick_quote')}
                  </button>
                )}
                {sub.id === 'proc' && !!document.getElementById('sb-quick-log') && (
                  <button type="button" className="sm-action" onClick={() => { setSecOpen(false); document.getElementById('sb-quick-log').click(); }}>
                    {label('proc.quick_log')}
                  </button>
                )}
              </div>
              <SubmenuList
                nav={sub.nav}
                activeItem={sub.activeItem}
                user={host.user()}
                host={host}
                moduleId={sub.id}
                onSelect={(itemId) => { setSecOpen(false); host.navigate(sub.id, itemId); }}
              />
            </React.Fragment>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}
